import { parseParameters } from "@gr-exports/async/attribute-parser";
import { noop } from "@gr-common/async/function";
import { DATA_BASE_ATTR } from "../parser/elements.js";
import { lifecycleEvents, dispatchTrackingEvent, synteticEvents } from "../event/event.js";
import { dataContainerParam, parserParametersOptions } from "../parser/params.js";
import { loggerScope } from "../parser/utils.js";
import { PREFIX } from "../index.js";
import type { Unset } from "../../event/head.js";

/**
 *
 */
export const EVENT_NAME = synteticEvents[0];
const log = loggerScope.scope(EVENT_NAME);

export const observed = new WeakMap<
  Element,
  [IntersectionObserver, Required<VisibilityTriggerOptions>]
>();

export const observers = new Map<string, IntersectionObserver>();

export type VisibilityTriggerOptions = {
  /**
 *
 */
  once?: boolean;
};

export type visibilityObserverOptions = IntersectionObserverInit & VisibilityTriggerOptions;

/**
 *
 *
 *
 *
 */
const unregister = (elementToTrack: HTMLElement): void => {
  const observerOptions = observed.get(elementToTrack);
  /*                          */
  if (!observerOptions) return;

  /*                                         */
  observerOptions[0].unobserve(elementToTrack);
  observed.delete(elementToTrack);
};

/**
 *
 *
 *
 *
 *
 */
export const processObserverEntry = (entry: IntersectionObserverEntry): void => {
  /*                  */
  const elementToTRack = entry.target as HTMLElement;
  const observedOptions = observed.get(elementToTRack);

  /*                                                    */
  if (!observedOptions || !entry.isIntersecting) return;

  /*                                                      */
  if (observedOptions[1].once) unregister(elementToTRack);

  /*                                    */
  dispatchTrackingEvent(entry.target, EVENT_NAME, {
    entry,
    [PREFIX]: { method: "submitMiniAction" },
  });
};

/**
 *
 *
 */
export const observerCallback = ((entries) =>
  entries.forEach(processObserverEntry)) satisfies IntersectionObserverCallback;

/**
 *
 *
 *
 */
const register = (elementToTrack: HTMLElement): Unset => {
  if (observed.has(elementToTrack)) {
    /*                */
    return noop;
  }

  log.info("Initialize visibility tracking", elementToTrack);

  const config = parseParameters(
    DATA_BASE_ATTR,
    EVENT_NAME,
    elementToTrack,
    parserParametersOptions,
    { expandUnnamedAs: dataContainerParam },
  );

  /*                                */
  const { once = false, ...observerInit } =
    (config.observer as Partial<visibilityObserverOptions>) ?? {};

  /*                                           */
  /*                                                     */
  const initID = JSON.stringify(observerInit);

  let observer = observers.get(initID);
  if (!observer) {
    log.info("Instanciating new IntersectionObserver for", observerInit);
    /*                                               */
    if (typeof observerInit.root === "string") {
      observerInit.root = elementToTrack.closest(observerInit.root);
    }

    /*                                                                */
    observer = new IntersectionObserver(observerCallback, observerInit);
    observers.set(initID, observer);
  }

  if (
    !dispatchTrackingEvent(elementToTrack, lifecycleEvents[1], {
      event: synteticEvents[0],
      options: { observer: observerInit },
    })
  ) {
    log.debug("Visibility tracking has been terminated by lifecycle hook", elementToTrack);
    return noop;
  }

  /*              */
  observed.set(elementToTrack, [observer, { once }]);
  observer.observe(elementToTrack);

  /*                         */
  return () => unregister(elementToTrack);
};

const synteticBecomeVisible = [synteticEvents[0], register] as const;
export default synteticBecomeVisible;
